import moment, { Moment } from 'moment';

export const disabledTime = (selectedDate: Moment | null) => {
  const currentDate = moment();

  if (selectedDate?.isBefore(currentDate)) {
    const currentTime = currentDate.hour();
    const currentMinute = currentDate.minute();

    return {
      disabledHours: () => Array.from({ length: currentTime }, (_, i) => i),
      disabledMinutes: (hour: number) => {
        if (hour === currentDate.hour()) {
          return Array.from({ length: currentMinute }, (_, i) => i);
        }
        return [];
      },
    };
  }

  return {};
};
